export const SETTINGS_LOADED = 'SETTINGS_LOADED';
export const SAVE_TCPP = 'SAVE_TCPP';
